import React from "react";

// components
import SectionContainer from "core/SectionContainer";
import HeroLandingPage from "core/HeroLandingPage";
import OffsetGrid from "core/OffsetGrid";
import BulletSection from "core/BulletSection";
import Collections from "core/Collections";
import BlogPosts from "core/BlogPosts";
import PageMeta from "core/PageMeta";
import IconsSection from "marketing-pages/PricingMarketingPage/IconsSection";

// styles
import colors from "core/colors";
import { HeroSectionContainer } from "./styles";

// data
import {
    titleTag,
    metaDescription,
    heroImages,
    heroHeading,
    bullets,
    collectionsTitle,
    collections,
    pills,
    pillsTitle,
    iconHighlightTitle,
    iconHighlightsData
} from "./data";

const IconLandingPage = () => {
    const structuredDataForSEO = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "The Noun Project",
        alternateName: "The Noun Project, Inc.",
        url: "https://thenounproject.com/icons/",
        headline: "The World’s Most Diverse and Extensive Icon Collection",
        description:
            "Noun Project features the most diverse collection of icons ever. Download SVG and PNG. Millions of free icons or unlimited royalty-free icons with NounPro.",
        logo:
            "https://static.production.thenounproject.com/img/nounproject_logo.60e860f212a5.png",
        inLanguage: "en",
        sameAs: [
            "https://twitter.com/nounproject",
            "https://www.facebook.com/thenounproject",
            "https://www.instagram.com/nounproject/",
            "https://dribbble.com/nounproject",
            "https://www.behance.net/noun_project",
            "https://en.wikipedia.org/wiki/The_Noun_Project"
        ],
        potentialAction: {
            "@type": "SearchAction",
            target:
                "https://thenounproject.com/search/icons/?q={search_term_string}",
            "query-input": "required name=search_term_string"
        }
    };

    return (
        <>
            <PageMeta
                title={titleTag}
                indexContent="index,follow,max-image-preview:large"
                description={metaDescription}
                structuredData={structuredDataForSEO}
                canonicalURL="https://thenounproject.com/icons/"
            />
            <HeroSectionContainer
                bgColor={colors.secondary.orca}
                textColor={colors.primary.diamond}
                topSpacing="none"
                bottomSpacing="4xl"
            >
                <OffsetGrid sm={10} md={12} lg={12}>
                    <HeroLandingPage
                        isIconLandingPage
                        heroImages={heroImages}
                        heading={heroHeading}
                        headingColor={colors.primary.diamond}
                        bgSizeTablet="55% auto"
                        bgPositionTablet="center right"
                        bgSizeDesktop="50% 90%"
                        bgPositionDesktop="650px 75px"
                    />
                </OffsetGrid>
            </HeroSectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <BulletSection bullets={bullets} />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer bgColor={colors.primary.diamond}>
                <Collections
                    title={collectionsTitle}
                    collections={collections}
                    pillsTitle={pillsTitle}
                    pills={pills}
                />
            </SectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <BlogPosts
                        posts={iconHighlightsData}
                        blogPostsTitle={iconHighlightTitle}
                    />
                </OffsetGrid>
            </SectionContainer>

            <IconsSection bgColor={colors.primary.diamond} />
        </>
    );
};

export default IconLandingPage;
